import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  profileByUserId: {},
  statisticsByUserId: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.PEOPLE__PROFILE_LOADED:
      return {
        ...state,
        profileByUserId: {
          ...state.profileByUserId,
          [action.payload.userId]: action.payload.profile,
        },
      };

    case AppConstants.PEOPLE__PROFILE_STATISTICS_LOADED:
      return {
        ...state,
        statisticsByUserId: {
          ...state.statisticsByUserId,
          [action.payload.userId]: action.payload.statistics,
        },
      };

    case AppConstants.PEOPLE__PROFILE_EDIT_STARTED:
    case AppConstants.PEOPLE__PROFILE_EDIT_FINISHED:
      return {
        ...state,
        profileByUserId: {
          ...state.profileByUserId,
          [action.payload.userId]: action.payload.profile,
        },
      };

    default:
      return state;
  }
};
